import React, { Component } from 'react';

export default class ImageUploadField extends Component {

  constructor(props, context) {
    super(props, context);
  };

  showDirectUpload = (e, fieldName, field) => {
    e.preventDefault();    
    this.props.showDirectUploaderModal(fieldName, field)
  }

  componentDidMount(){

  }

 /*
  componentWillReceiveProps(nextProps) {
      if ((this.props.directUploadUrl !== nextProps.directUploadUrl)) {
        if(nextProps.directUploadUrl){
 
          this.props.setFieldValue(this.props.field.name, nextProps.directUploadUrl)
          let values = this.props.values;
          values[this.props.field.name] = nextProps.directUploadUrl;
          store.dispatch(queProof(this.props.productData[0].id, values, this.props.editorCurrentPage));

        }
      }
  }

  */

  render() {

    return <div className={"coreprint-editor-field-wrapper pageno" + this.props.field.pageNumber}>
              <label style={{"display":"none"}} className="label">{this.props.field.label}</label>
              <div className="control">
                <input
                  type="hidden"
                  name={this.props.field.name}
                  onChange={(e) => this.props.handleChange(e, this.props.field.name)}
                  placeholder={this.props.field.name}
                  value={this.props.values[this.props.field.name]}
                  className="input"
                />

                <button style={{"display":"none"}} onClick={(e) => this.showDirectUpload(e, this.props.field.name)} class="button">{this.props.field.label}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  style={{"width":"18px","margin-left":"15px"}}
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path fill="#363636" d="M16 16h-3v5h-2v-5H8l4-4 4 4zm3.479-5.908C19.267 6.141 16.006 3 12 3s-7.267 3.141-7.479 7.092A5.499 5.499 0 005.5 21H9v-2H5.5C3.57 19 2 17.43 2 15.5c0-2.797 2.479-3.833 4.433-3.72C6.266 7.562 8.641 5 12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5H15v2h3.5a5.499 5.499 0 00.979-10.908z"></path>
                </svg></button>


                <button onClick={(e) => this.showDirectUpload(e, this.props.field.name, this.props.field)} class="button dam-link">{this.props.field.label}</button>
              </div>
            </div>

  }

}




